import { select, put, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import GlobalActions from 'store/redux/global'
import PhaseInfoActions from 'store/redux/phaseInfo'
import AuthActions from 'store/redux/auth'
import Socket from 'api'
import PHASE from 'utils/constants/phases'

export function* endPhase() {
    yield put(GlobalActions.cleanModal())
    yield put(GlobalActions.showLoading())
    const { phaseInfo: { phase, totalSeasons, totalRaces, season, race }, selection } = yield select(state => ({
        phaseInfo: state.phaseInfo,
        selection: state.phase.selection
    }))
    if (phase === PHASE.POST_SEASON && season === totalSeasons && race === totalRaces) {
        yield call(Socket.emitters().status.sendSelection, { phase, selection })
        yield put(AuthActions.signout(false))
    } else {
        Socket.emitters().status.sendSelection({ phase, selection })
        yield put(PhaseInfoActions.setFinished(true))
        yield put(push('/loading'))
    }
    yield put(GlobalActions.hideLoading())
}



// WEBPACK FOOTER //
// src/store/sagas/phase.js